export default __webpack_public_path__ + "static/media/scBW.7f6002b1.webp";